<script lang="ts">
  import { addStudent } from '$lib/api/classes';
  import { listStudentsForAddingToClass } from '$lib/api/users';
  import { toast } from '$lib/stores/toast.svelte';
  import Label from '../common/bootstrap/Label.svelte';
  import ClinicalGroupQuickSearch from '../common/ClinicalGroupQuickSearch.svelte';
  import FormModal from '../common/modal/FormModal.svelte';
  import QuickSearch from '../common/QuickSearch.svelte';

  interface Props {
    classId: number;
    isAddingStudent: boolean;
  }

  let { classId, isAddingStudent = $bindable() }: Props = $props();

  let studentValue: string | null = $state(null);
  let studentTouched = $state(false);
  let clinicalGroupValue: string | null = $state(null);
  let clinicalGroupTouched = $state(false);
</script>

<FormModal
  formId="add_student_to_class"
  onclose={() => (isAddingStudent = false)}
  validationChecks={() => {
    clinicalGroupTouched = true;
    studentTouched = true;
    return clinicalGroupValue != null;
  }}
  onsubmit={async () => {
    await addStudent(classId, parseInt(studentValue!), parseInt(clinicalGroupValue!));
    toast.showToast('success', 'Student has been added to the class!');
    return true;
  }}
  header="Add Student"
  scrollable={false}
  invalidateUrl={url => url.pathname.startsWith('/api/classes')}
>
  <p>
    Select a student and clinical group to add to the class. Only students are listed that have not already been added
    to the class.
  </p>
  <div class="mb-3">
    <Label for="add_student_to_class_cg_qs">Student</Label>
    <QuickSearch
      placeholder="Choose Student"
      feedback="Please choose a student"
      id="student_quick_search"
      bind:value={studentValue}
      emptySearchResultsLabel="No students found!"
      invalid={studentTouched && studentValue === null}
      bind:touched={studentTouched}
      loadData={async (query, page, pageSize, signal) => {
        const users = await listStudentsForAddingToClass(classId, query, page, pageSize, signal);
        return users.map(u => {
          return {
            value: u.id.toString(),
            text: `${u.lastName}, ${u.firstName}`,
            title: `${u.lastName}, ${u.firstName}`,
          };
        });
      }}
    />
  </div>
  <div class="mb-3">
    <Label for="add_student_to_class_cg_qs">Clinical Group</Label>
    <ClinicalGroupQuickSearch
      {classId}
      bind:touched={clinicalGroupTouched}
      id="add_student_to_class_cg_qs"
      required
      bind:value={clinicalGroupValue}
    />
  </div>
</FormModal>
